import { DTONpmRegistryConfig } from "../workspaces";
import { z } from "zod";
/**
 * @deprecated
 */
export const DTOForgeProjectContext = z.object({
    definition: z.string(),
    dependencies: z.array(z.object({
        packageName: z.string(),
        type: z.literal("npm"),
        version: z.string().default("latest"),
    })),
    designSystemId: z.string(),
    id: z.string(),
    meta: z.object({
        name: z.string(),
        description: z.string().optional(),
    }),
    name: z.string(),
    npmProxySettings: DTONpmRegistryConfig.optional(),
    platform: z.enum(["React", "Vue", "Angular"]),
    styling: z.enum(["CSS", "Tailwind"]),
    tailwindConfig: z
        .object({
        content: z.string(),
        version: z.string(),
    })
        .optional(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    workspaceId: z.string(),
});
export const DTOCreateForgeProjectContext = DTOForgeProjectContext.pick({
    definition: true,
    name: true,
    meta: true,
    designSystemId: true,
    platform: true,
    dependencies: true,
    tailwindConfig: true,
    styling: true,
}).extend({ npmProxySettings: DTONpmRegistryConfig });
export const DTOUpdateForgeProjectContext = DTOCreateForgeProjectContext.partial().extend({ id: z.string() });
export const DTOForgeProjectContextGetResponse = z.object({
    context: DTOForgeProjectContext,
});
export const DTOForgeProjectContextListResponse = z.object({
    contexts: z.array(DTOForgeProjectContext),
});
export const DTOForgeProjectContextCreateResponse = z.object({
    context: DTOForgeProjectContext,
});
export const DTOForgeProjectContextUpdateResponse = z.object({
    context: DTOForgeProjectContext,
});
export const DTOForgeProjectContextRemoveResponse = z.object({
    ok: z.literal(true),
});
